import { render, staticRenderFns } from "./FirmCommentLayer.vue?vue&type=template&id=5e4c8741&scoped=true&"
import script from "./FirmCommentLayer.vue?vue&type=script&lang=js&"
export * from "./FirmCommentLayer.vue?vue&type=script&lang=js&"
import style0 from "./FirmCommentLayer.vue?vue&type=style&index=0&id=5e4c8741&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c8741",
  null
  
)

export default component.exports